(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["northline-offer"]) return;
  try {
    
if (!customElements.get('northline-offer')) {
  customElements.define('northline-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.key = this.dataset.offerKey || 'northline-signup-v1';
      if (!this.dialog || this.hasAttribute('data-design-mode')) return;
      const success = this.querySelector('[data-offer-success]');
      const hasError = this.querySelector('.nl-offer__error');

      this.querySelectorAll('[data-offer-close]').forEach(b => b.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      });
      const copy = this.querySelector('[data-offer-copy]');
      if (copy) copy.addEventListener('click', async () => {
        const code = this.querySelector('[data-offer-code]').textContent.trim();
        const status = this.querySelector('[role="status"]');
        try { await navigator.clipboard.writeText(code); status.textContent = 'Copied. Enter it at checkout.'; }
        catch { status.textContent = 'Enter ' + code + ' at checkout.'; }
      });
      this.dialog.addEventListener('close', () => {
        if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll:true});
      });

      // Just signed up, or the email had an error: open right away.
      if (success || hasError) {
        if (success) { try { localStorage.setItem(this.key + '-subscribed', '1'); } catch {} }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        return;
      }
      // Already subscribed on this browser: never show again.
      try { if (localStorage.getItem(this.key + '-subscribed')) return; } catch {}

      this.showOffer = () => {
        try { if (sessionStorage.getItem(this.key)) return; } catch {}
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open], [aria-modal="true"]')) {
          this.timer = setTimeout(this.showOffer, 2500);
          return;
        }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        try { sessionStorage.setItem(this.key, 'shown'); } catch {}
      };
      this.timer = setTimeout(this.showOffer, Number(this.dataset.delay || 8) * 1000);
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
